import { Component, OnInit, HostListener, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { ApifirstService } from 'src/app/service/apifirst.service';
import { FdrsClientService } from 'src/app/service/fdrs-client.service';
import { RenderOtxCandidateService } from 'src/app/service/render-otx-candidate.service';
import { removeFocus } from '../../../assets/js/FDT-EU/abortOTX'
import { openDialog } from '../../../assets/js/FDT-EU/abortOTX'
import { ReportAProblemPageComponent } from '../report-a-problem-page/report-a-problem-page.component';
import { RpcClientService } from 'src/app/service/rpc-client.service';
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: 'app-otx-candidate',
  templateUrl: './otx-candidate.component.html',
  styleUrls: ['./otx-candidate.component.scss']
})
export class OtxCandidateComponent implements OnInit {
  public candidateId = '';
  public sessionId: any;
  public qidRes: any;
  public res: any;
  public invinnumber = ''
  public isNetwork = false;
  tokenObj: any;
  language: any;
  countryCode: any;
  queueId: any;
  candidateData: any;
  fromResume = false;
  pageData: any;
  public btnName: string = '';
  procedureType: string = '';
  showSpinner: boolean = false;
  RAPBtnStatus: boolean = false;
  technicalproblem: string = '';
  showNotification: boolean = false;
  errorPopUpSubscription: Subscription = new Subscription;
  @ViewChild('OTXErrorInfo') OTXError: ElementRef | undefined | null = null;
  @ViewChild('gtacRap') gtacRap: ElementRef | undefined;
  @ViewChild('content') content: ElementRef | undefined;
  @ViewChild('invalidApp') invalidApp: ElementRef | undefined;
  @ViewChild('anotherAppActive') anotherAppActive: ElementRef | undefined;

  edmMarkets: any = ['AL', 'AM', 'AZ', 'BA', 'BY', 'BG', 'HR', 'CY', 'EE', 'FK', 'GI', 'GE', 'GS', 'KZ', 'LV', 'LT', 'MT', 'MD', 'MK', 'CS', , 'UA', 'TR', 'SI', 'SK', 'CS']
  navigationScreen: string = ''
  public tokenDetails: any
  public Vinnumber: any;
  public currentVin: any;
  public userType: any;
  public country: any;
  public lang: any;
  public market: any;
  public username: any;
  public countrythree: any;
  public dealerCode: any;
  public vindetails: any;
  public modelYear: any;
  public vehicle: any;
  public candidateArray: any;
  otxcandidateArraySubscription: Subscription = new Subscription;
  constructor(private service: ApifirstService, private renderOtxCandidateService: RenderOtxCandidateService, private fdrsClient: FdrsClientService, private modalService: NgbModal, private router: Router, private rpcClient: RpcClientService,private spinnerService: NgxSpinnerService) { }

  ngOnInit(): void {
    this.service.candidateId.subscribe((data) => {
      this.candidateId = data
    })
    this.service.selectedDiagnosticProcedureData$.subscribe((data) => {
      this.candidateData = data;
    })
    this.service.RAPSubmitBtnStatus.subscribe((data) => {
      this.RAPBtnStatus = data;
    })
    this.errorPopUpSubscription = this.service.showOTXErrorPopUp.subscribe((data: any) => {
      if (Object.keys(data).length > 0) {
        this.navigationScreen = data.ScreenName;
        this.technicalproblem = data.reason;
        this.modalService.open(this.OTXError);
        const vinDetails = this.service.getVinDetailsSnapshot();
        // Call reportdetails API here
        let reportdto = {
          "vin": this.tokenDetails.vin,
          "id": '1001',
          "vehicleType":vinDetails?.vehicleLineDescription,
          "market": this.tokenDetails.marketCountry,
          "dealerCode": this.tokenDetails.dealerCode,
          "gnumber": data.gnumber
        };
        this.service.reportdetails(reportdto).subscribe((response) => {
          console.log("Report details sent:", response);
        }, (error) => {
          console.error("Error sending report details:", error);
        });
      }
    })

    this.otxcandidateArraySubscription = this.service.otxStateChangeObj.subscribe((data)=> {
      this.candidateArray = data;
    })

    this.service.show_Another_App_Active_popup.subscribe((data)=> {
      if(data == 'true') {
        console.log('=====================Active Popup======================',data);
        this.modalService.open(this.anotherAppActive, { size: 'md' });
      } else if(data == 'false'){
        this.showNotification = false;
        this.spinnerService.hide();
      }
    })

    this.service.tokenObj.subscribe((data) => {
      this.tokenDetails = data
      this.Vinnumber = this.tokenDetails.vin
      this.currentVin = this.tokenDetails.vin
      this.userType = this.tokenDetails.userType
      this.country = this.tokenDetails.country;
      this.lang = this.tokenDetails.language;
      this.market = this.tokenDetails.marketCountry
      this.username = this.tokenDetails.username
      this.countrythree = this.tokenDetails.countryThree
      this.dealerCode = this.tokenDetails.dealerCode

    })

    this.service.navigatePreviousScreen.subscribe((data) => {
      if (data == 'repairProcedure') {
        this.btnName = "REPAIR CANDIDATES"
        this.procedureType = "REPAIR"
      } else if (data == 'postRepairProcedure') {
        this.btnName = "POST REPAIR CANDIDATES"
        this.procedureType = "POST_REPAIR"
      } else if (data == 'diagnosticProcedure') {
        this.btnName = 'Diagnostic Candidates'
        this.procedureType = 'DIAGNOSTIC'
      }
    })

    this.renderOtxCandidate();

    this.fdrsClient.getFdtUtil().deferredApplicationQueue.then((data: any) => {
      console.log("Abort Notification Queue:", data)
    })

    this.service.showOtxSpinner.subscribe((data) => {
      this.showSpinner = data;
    })
  }

  @HostListener("window:click", ["$event"])

  onScroll(event: any) {
    console.log("User Clicked on Window..." + event.target.id);
    if (event.target.id == 'btnTxtReportAProblem') {
      this.openGtacRAPConfirmationPopUp();
    } else if (event.target.id == 'RAPSubmitBtnClick') {
      if (this.RAPBtnStatus) {
        openDialog();
      }
    } else if (event.target.id == 'RAPCrossBtnClick') {
      openDialog()
    } else if(event.target.id == 'btnTxtGtac') {
      this.contactSubmit(this.content);
    }
  }

  openGtacRAPConfirmationPopUp() {
    this.modalService.open(this.gtacRap, { size: 'md' });
  }

  abortAnotherAppActive() {
    this.showNotification = true;
    this.spinnerService.show();
    this.rpcClient.getQueue().abortOtxApplication();
  }

  reportAProblemPopup() {
    this.service.sendGnumberToRAP.next(this.candidateId);
    removeFocus();
    const modalRef = this.modalService.open(ReportAProblemPageComponent, {
      windowClass: "myCustomModalClass",
      backdrop: 'static'
    });
    modalRef.result.then(
      result => {
        console.log(result);
      },
      reason => { }
    );
    setTimeout(() => {
      let el = document.getElementById("firstName") as HTMLElement;
      el.focus();
    }, 0)
  }

   contactSubmit(content: any) {
    if (!this.edmMarkets.includes(this.tokenDetails['country'])) {
      this.service.vindetail.subscribe((data) => {
        this.vindetails = data
        console.log(this.vindetails, "vindetails")
        this.modelYear = this.vindetails.modelYear
        this.vehicle = this.vindetails.vehicleLineDescription
        if(this.countrythree == 'ROM') {
          this.countrythree = 'ROU';
        }
        const newWindow = window.open(this.service.gtacUrl + 'LANG=' + this.lang + '-US&Contactid=&vin=' + this.Vinnumber + '&USERID=' + this.username + '&Symptom_codes=12&GEO=' + this.countrythree + '&PACODE=' + this.dealerCode + '&countryCode=' + this.countrythree + '&Model=' + this.vehicle + '&Year=' + this.modelYear, '_blank', 'width=700,height=700');
      }
      )
    }
    else {
      this.modalService.open(content, {
        centered: true,
        backdrop: 'static', size: 'md'
      });
    }
  }

  raiseGTACForInvalidApp(content: any) {
    if (!this.edmMarkets.includes(this.tokenDetails['country'])) {
      this.service.vindetail.subscribe((data) => {
        this.vindetails = data
        console.log(this.vindetails, "vindetails")
        this.modelYear = this.vindetails.modelYear
        this.vehicle = this.vindetails.vehicleLineDescription
        if(this.countrythree == 'ROM') {
          this.countrythree = 'ROU';
        }
        const newWindow = window.open(this.service.gtacUrl + 'LANG=' + this.lang + '-US&Contactid=&vin=' + this.Vinnumber + '&USERID=' + this.username + '&Symptom_codes=12&GEO=' + this.countrythree + '&PACODE=' + this.dealerCode + '&countryCode=' + this.countrythree + '&Model=' + this.vehicle + '&Year=' + this.modelYear, '_blank', 'width=700,height=700');
        this.navigatePreviousScreen();
      }
      )
    }
    else {
      this.modalService.open(content, {
        centered: true,
        backdrop: 'static', size: 'md'
      });
      this.navigatePreviousScreen();
    }
  }

  renderOtxCandidate() {
    console.log('renderOtxCandidateOTX:', this.candidateId);
    this.service.tokenObj.subscribe((data) => {
      this.res = data;
      this.invinnumber = this.res.vin
      this.language = this.res.language.toLowerCase()
      this.countryCode = this.res.country
      this.sessionId = localStorage.getItem("sessionID")

      let reqBodyForSessionId =
      {
        "sessionId": this.sessionId
      }
      console.log("req", this.language, this.countryCode, reqBodyForSessionId);
      this.getQueueId(this.language, this.countryCode, reqBodyForSessionId);
    })
  }

  getQueueId(language: string, countryCode: string, reqBodyForSessionId: any) {
    this.service.queueIdRes(language, countryCode, reqBodyForSessionId, this.candidateId, this.procedureType).subscribe((data) => {
      this.qidRes = data;
      if(this.qidRes == 'invalidApp') {
        this.modalService.open(this.invalidApp, { size: 'md' });
      } else {
        this.renderOtxCandidateService.tryFDTConnection(this.candidateId, this.qidRes);
      }
    })
  }

  navigate() {
    if (this.navigationScreen == 'repairProcedure') {
      this.service.showOTXErrorPopUp.next({});
      this.router.navigate(['/repairProcedures'])
    } else if (this.navigationScreen == 'postRepairProcedure') {
      this.service.showOTXErrorPopUp.next({});
      this.router.navigate(['/postrepairProcedures'])
    } else if (this.navigationScreen == 'diagnosticProcedure') {
      this.service.showOTXErrorPopUp.next({});
      this.router.navigate(['/info'])
    }
  }

  navigatePreviousScreen() {
    if (this.btnName == 'REPAIR CANDIDATES') {
      this.router.navigate(['/repairProcedures'])
    } else if (this.btnName == 'POST REPAIR CANDIDATES') {
      this.router.navigate(['/postrepairProcedures'])
    } else if (this.btnName == 'Diagnostic Candidates') {
      console.log('-------------Candidate Data-------------',this.candidateData);
      console.log('--------------candidate Array----------', this.candidateArray);
      this.service.pageData.next('');
      this.service.otxStateChangeObj.next(this.candidateArray);
      if(this.candidateData[0].state == 'Untested') {
        this.service.OTXinvalidAppSkipTest.next({
          "id": this.candidateId,
          "index": this.candidateData[0].index,
          "state": this.candidateData[0].state
        })
      }
      this.router.navigate(['/info'])
    }
  }

  ngOnDestroy() {
    this.errorPopUpSubscription.unsubscribe();
    this.otxcandidateArraySubscription.unsubscribe();
  }
}
